import { FormGroup } from '@angular/forms';

// TODO: re-type this when possible
// import { FactoryType } from '../../ui-factories/factory-type';
import { globalMap, factoryMap } from './global-state';

export class BehaviorContext {
  targetType: any; // FactoryType
  target: any;
  formGroup: FormGroup;

  constructor(data) {
    this.targetType = data.targetType;
    this.target = data.target;
    this.formGroup = data.formGroup;
  }

  set(key, val) {
    globalMap.set(key, val);
  }

  merge(key, val) {
    const existing = globalMap.get(key);
    const next = { ...existing, ...val };
    globalMap.set(key, next);
  }

  get(key) {
    return globalMap.get(key);
  }

  has(key) {
    return globalMap.has(key);
  }

  getFactoryById(id) {
    return factoryMap.get(id);
  }
}
